import script from "./AppSlippageForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSlippageForm.vue?vue&type=script&setup=true&lang=ts"

import "./AppSlippageForm.vue?vue&type=style&index=0&id=38a76f23&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38a76f23"]])

export default __exports__